/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFacebookIcon16Light = forwardRef('LogoFacebookIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.125 4.5c0-.76.616-1.375 1.375-1.375h1a.625.625 0 1 0 0-1.25h-1A2.625 2.625 0 0 0 6.875 4.5v1.375H5a.625.625 0 1 0 0 1.25h1.875V13a.625.625 0 1 0 1.25 0V7.125H10a.625.625 0 1 0 0-1.25H8.125V4.5Z" })));
});
